import { ADD_PROPERTY } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_PROPERTY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_PROPERTY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_PROPERTY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
